 /**
 * article模块接口列表
 */

// import qs from 'qs'; // 根据需求是否导入qs模块
import base from '../base'; // 导入接口域名列表
import axios from '../request'; // 导入http中创建的axios实例
import qs from 'qs'; 
 
 

const answerList = {
 // 查询单节直播课信息
 queryLive (data) {
    return axios.get(`${base.sq}/api/answer/ansAnswer/queryAnsAnswerById?id=${data.liveId}&companyId=${data.companyId} `)
  },
  // 查询聊天室历史消息
  queryCommonMessage(data) {
    return axios.get(`${base.sq}/netty/chatMessage/queryCommonChatMessage?liveId=${data.liveId}&companyId=${data.companyId}&pageSize=${data.pageSize}&messageId=${data.messageId} `)
  },
  //查询分析师
  queryAnalystMessage(data) {
    return axios.get(`${base.sq}/netty/chatMessage/queryAnalystChatMessage?liveId=${data.liveId}&companyId=${data.companyId}&pageSize=${data.pageSize}&messageId=${data.messageId}`)
  },
  //查询与我相关
  queryRelatedMessage (data) {
    return axios.get(`${base.sq}/netty/chatMessage/queryRelatedChatMessage?liveId=${data.liveId}&companyId=${data.companyId}&pageSize=${data.pageSize}&messageId=${data.messageId}&userToken=${data.userToken}`)
  },
  // 查询客服私聊
  queryServiceMessage (data) {
    return axios.get(`${base.sq}/netty/chatMessage/queryServiceChatMessage?liveId=${data.liveId}&companyId=${data.companyId}&pageSize=${data.pageSize}&messageId=${data.messageId}&userToken=${data.userToken}`)
  },
  // 查询置顶
  queryTopChatMessage(data) {
    return axios.get(`${base.sq}/netty/chatMessage/queryTopChatMessage?liveId=${data.liveId}&companyId=${data.companyId}`)
  },
  // 查询跟客服的消息
  queryServiceMessageCount(data) {
    return axios.get(`${base.sq}/netty/chat/queryUserMessageMark?liveId=${data.liveId}&companyId=${data.companyId}&userToken=${data.userToken}`)
  },
  //删除查看的消息
  deleteUserMessageMark(data) {
    return axios.get(`${base.sq}/netty/chat/deleteUserMessageMark?liveId=${data.liveId}&companyId=${data.companyId}&userToken=${data.userToken}`)
  },
   //分时图
   getTimeline(data) {
    return axios.post(`${base.trade}/newmis36/api/kcharts/gettimeline`,qs.stringify(data))
  },
  //k线图
  getKline(data){
    return axios.post(`${base.trade}/newmis36/api/kcharts/getkChartsByType`,qs.stringify(data))
  }

}
export default answerList;